module.exports = __webpack_public_path__ + "static/media/internal_env_3_media_7.fff3425e.webp";